import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfigModule } from 'Angular/config/config.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { NotificationsMenuListItemComponent } from 'NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-list-item/notifications-menu-list-item.component';
import { NotificationsMenuReportHistoryItemComponent } from 'NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-report-history-item/notifications-menu-report-history-item.component';
import { NotificationsSideMenuComponent } from 'NotificationsApp/ts/features/notifications-side-menu/components/notifications-side-menu/notifications-side-menu.component';

@NgModule({
    declarations: [
        NotificationsMenuListItemComponent,
        NotificationsSideMenuComponent,
        NotificationsMenuReportHistoryItemComponent,
    ],
    imports: [CommonModule, ConfigModule, IconModule, TooltipModule],
    exports: [NotificationsMenuListItemComponent, NotificationsSideMenuComponent],
})
export class NotificationsSideMenuModule {}
